function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.99901549,5.02488383 L10.4532697,1 L14.4248093,1 L9.80849522,7.95631693 L14.5,15 L10.5287431,15 L8.00064654,10.9028991 L5.49465917,15 L1.5,15 L6.17048158,7.97238103 L1.52729447,1 L5.52223795,1 L7.99901549,5.02488383 Z M8.52005119,5.87159214 L9.29447314,7.13006543 L12.7818117,1.875 L10.957054,1.875 L8.52005119,5.87159214 Z M9.29648061,8.7843079 L8.51867222,10.0559661 L11.0294502,14.125 L12.8536938,14.125 L9.29648061,8.7843079 Z"
});

var SvgMax = function SvgMax(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MAX.8892739e.svg";
export { ForwardRef as ReactComponent };